define('shared/remote/member/get',[
    '$',
    './cache',
    'shared/remote/ajax',
    'shared/lib/RSVP', 
    'shared/my/cmus',
    'shared/my/efid',
    'shared/page/apiVersion'
],
function ($, cache, ajax, RSVP, getCMus, efid, getAPIVersion) {
    'use strict';
    
    var promises = {};

    function sendRequestOldHouse(cmus) {
        return $.ajax({
                url: '/services/commerce-v4/MemberManager/GetMember',
                type: 'GET',
                dataType: 'json',
                data: {
                    cmus: cmus
                }
            });
    }

    function sendRequestNewHouse() {
        return ajax({
                url: '/1/api/commerce-gateway/member',
                method: 'get'
            });
    }

    function getFromServer(storageKey){
        if (!storageKey) {
            return RSVP.resolve(null);
        }
        return getAPIVersion()
            .then(function(api){
                if (api === 'new-house') {
                    return sendRequestNewHouse(storageKey)
                        .then(function(json){
                            if (json == null) {
                                return RSVP.reject('Server side failed to return member info');
                            }

                            return cache.set(storageKey, json)
                                .then(function(){
                                    return json;
                                });
                        }, function(xhr){
                            if (xhr.status === 404) {
                                return RSVP.resolve(null);
                            }

                            var err = new Error('Network error');
                            return RSVP.reject(err);
                        });
                }
                else {
                    return sendRequestOldHouse(storageKey)
                        .then(function(json){
                            if ( json == null || json.Success === false || json.Result == null ) {
                                return RSVP.reject('Server side failed to return member info');
                            }

                            var member = json.Result;

                            return cache
                                .set(storageKey, member)
                                .then(function(){
                                    return RSVP.resolve(member);
                                });
                        },
                        function(){
                            return RSVP.reject('Network failure while retrieving member info');
                        });
                }
            });
    }

    function get(){
        return getStorageKey()
            .then(function(storageKey){
                if(!storageKey){
                    return RSVP.resolve(null);
                }

                if (promises[storageKey]) {
                    return promises[storageKey];
                }

                return cache
                    .get(storageKey)
                    .then(function(member){
                        if (member) {
                            return RSVP.resolve(member);
                        }
                        else {
                            var ret = getFromServer(storageKey);
                            promises[storageKey] = ret;
                            return ret;
                        }
                    });
            });
    }

    function getStorageKey() {
        return getAPIVersion()
            .then(function(api){
                if (api === 'new-house') {
                    return efid.get();
                }
                else {
                    return getCMus();
                }
            });
    }

    return get;
});
